// Converting a middlegame advantage: the games where the reader stood winning
// before one of their middlegame moves (`ahead`), and of those not won, where
// the lead went (Tactic, Missed chance, Time, Positional, or no single
// mistake). Like `blunder` it lives in the scan's facts
// (`GameFacts.conversion`, sets by `conversionsOf`), which the filter does
// not read: whoever applies the filter resolves it first into `ids` (the
// game store's `resolveFilter`). Unresolved, it matches no game.
import { oneOf, type FilterCriterion } from '../criterion.ts';
import { CONVERSIONS, type Conversion } from '@chess/api-model';

const LABEL: Record<Conversion, string> = {
  ahead: 'Stood winning',
  tactic: 'Lead lost to a tactic',
  missed: 'Lead lost to a missed chance',
  time: 'Lead lost to the clock',
  positional: 'Lead lost positionally',
  none: 'Lead lost, no single mistake',
};

export const conversion: FilterCriterion<'conversion'> = {
  key: 'conversion',
  query: 'conversion',
  many: true,
  parse: oneOf(CONVERSIONS),
  format: (v) => v,
  matches: (_game, _v, filter) => !!filter.ids,
  control: {
    kind: 'choice',
    order: 68.5, // after Lost ground by (68)
    more: true,
    label: 'Middlegame lead',
    options: CONVERSIONS.map((c) => [c, LABEL[c]] as [Conversion, string]),
  },
};
